import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { Loader } from './../../../components/loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fetchImageDestroy } from '../actions/destroy';

class DestroyModal extends Component {
    componentDidUpdate(nextProps, nextState, nextContext) {
        if (
            this.props.destroyData.isFetching &&
            !nextProps.destroyData.isFetching &&
            !nextProps.destroyData.didInvalidate
        ) {
            this.props.closeModal();
        }
    }

    render() {
        const props = this.props,
            image = props.image,
            onDestroy = () =>
                props.destroyData.isFetching
                    ? null
                    : props.onDestroy(image.uuid);
        return (
            <div className="modal-body d-inline-block">
                {!props.destroyData.isFetching ? null : <Loader />}
                <div className="closeModal" onClick={this.props.closeModal}>
                    <FontAwesomeIcon icon="times" />
                </div>
                <div className="w-100">
                    <div className="">
                        <img
                            alt=""
                            src={'/image/small/' + image.name}
                            className="img-fluid d-block m-auto"
                        />
                    </div>
                    <h6>Вы действительно хотите удалить изображение?</h6>
                    <div className="text-center">
                        <Button color="success" onClick={onDestroy}>
                            Удалить
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

const MapStateToProps = function mapStateToProps(state) {
    return {
        destroyData: state.imagesState.destroyData,
    };
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        closeModal: () => {
            dispatch({
                type: 'closeMiniModal',
            });
        },
        onDestroy: (uuid) => {
            dispatch(fetchImageDestroy({ uuid: uuid }));
        },
    };
};

export const DestroyModalContainer = connect(
    MapStateToProps,
    mapDispatchToProps
)(DestroyModal);
